import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  IconButton,
  Stack,
} from "@mui/material";
import { Check } from "@mui/icons-material";
import {
  ExportCategory,
  ExportSettingItem,
} from "../../pages/Workspace/ExportModal/types";

interface Props {
  items: ExportSettingItem[];
  mainSelection: number;
  subSelection: number;
  onMainSelect: (mainIndex: number) => void;
  onSubSelect: (subIndex: number) => void;
  isAllowedCategory: (c: ExportCategory) => boolean;
}

export const ExportSettings: React.FC<Props> = ({
  items,
  mainSelection,
  subSelection,
  onMainSelect,
  isAllowedCategory,
  onSubSelect,
}) => {
  const handleMainSelection = (index: number) => {
    onMainSelect(index); // Notify parent of main selection
  };

  const handleSubSelection = (subIndex: number) => {
    onSubSelect(subIndex); // Notify parent of sub-selection
  };

  return (
    <Box width="40%" padding={3}>
      <List>
        {items.map((item, mainIndex) => (
          <ListItem
            key={mainIndex}
            data-testid={`export-settings-main-item-${mainIndex}`}
            disablePadding
            onClick={() => handleMainSelection(mainIndex)}
            sx={{ cursor: "pointer" }}
          >
            <Stack>
              <Stack direction="row">
                <IconButton
                  sx={{
                    width: 24,
                    height: 24,
                    backgroundColor:
                      mainSelection === mainIndex || mainSelection > mainIndex
                        ? "primary.main"
                        : "lightgray",
                    color: "white",
                    borderRadius: "50%",
                    marginRight: 2,
                    fontSize: 12,
                    "&:hover": {
                      backgroundColor:
                        mainSelection === mainIndex || mainSelection > mainIndex
                          ? "primary.dark"
                          : "lightgray",
                    },
                  }}
                >
                  {mainSelection > mainIndex ? (
                    <Check fontSize="small" />
                  ) : (
                    mainIndex + 1
                  )}
                </IconButton>
                <ListItemText sx={{ fontSize: 12 }} primary={item.main} />
              </Stack>
              {mainSelection > mainIndex && (
                <List sx={{ marginLeft: 1 }}>
                  <ListItem
                    sx={{
                      borderLeft: "3px solid",
                      borderColor: "primary.main",
                      color: "primary.main",
                      paddingLeft: 6,
                    }}
                  ></ListItem>
                </List>
              )}
              {mainSelection === mainIndex && (
                <List sx={{ marginLeft: 1 }}>
                  {item.subItems
                    ?.filter((subItem) =>
                      isAllowedCategory(subItem as ExportCategory)
                    )
                    ?.map((subItem, subIndex) => (
                      <ListItemButton
                        key={subItem}
                        data-testid={`export-settings-sub-item-${subIndex}`}
                        onClick={() => handleSubSelection(subIndex)}
                        sx={{
                          borderLeft: "3px solid",
                          borderColor: "primary.main",
                          color:
                            subSelection === subIndex
                              ? "primary.main"
                              : "text.secondary",
                          paddingLeft: 4,
                        }}
                      >
                        <Typography
                          sx={{
                            color:
                              subSelection === subIndex
                                ? "primary.main"
                                : "rgba(52, 60, 67, 0.6);",
                            paddingLeft: 1,
                          }}
                        >
                          {item.subItemLabels?.[subItem] ?? subItem}
                        </Typography>
                      </ListItemButton>
                    ))}
                </List>
              )}
            </Stack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
